import { useState } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import Tabs from 'src/components/ui/Tabs';
import SectionTitle from 'src/components/ui/SectionTitle';
import BackButton from 'src/components/BackButton';
import { ProfileTab, SecurityTab } from 'src/components/profile';

const ProfilePage = () => {
  const navigate = useNavigate();
  // Capture the hash once at mount. `defaultSelectedKey` is uncontrolled;
  // feeding it a value that changes with URL updates (as `useLocation().hash`
  // does after `onSelectionChange` writes back) triggers an infinite render
  // loop with @react-aria/collections v3.0.0-rc.0. See Issue #481.
  const [initialHash] = useState(() =>
    typeof window !== 'undefined' ? window.location.hash.replace(/^#/, '') : ''
  );

  return (
    <>
      <div className="flex items-center gap-2 px-6 py-4">
        <BackButton />
        <SectionTitle title="Profile" className="p-0" />
      </div>
      <div className="bg-surface-alt rounded-3xl shadow-3 mb-28">
        <Tabs
          ghost
          variant="secondary"
          tabListLabel="Profile Tabs"
          defaultSelectedKey={initialHash}
          onSelectionChange={(tabId) =>
            navigate({ hash: String(tabId), replace: true })
          }
          tabs={[
            {
              id: 'general',
              title: 'General',
              content: <ProfileTab />,
            },
            {
              id: 'security',
              title: 'Security',
              content: <SecurityTab />,
            },
          ]}
        />
      </div>
    </>
  );
};

export const Route = createFileRoute('/_authenticated/_layout-basic/profile')({
  component: ProfilePage,
});
